import CustomerTransactionListResourceModel from '../../generated/types/model/resource/CustomerTransactionListResourceModel';

export default class CustomerTransactionListResourceViewModel extends CustomerTransactionListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
